import React from 'react';

function ViewGotra({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  const displayFields = [
    { key: 'gotra_name', label: 'Gotra Name' },
    { key: 'status', label: 'Status' },
    { key: 'created_at', label: 'Created At' },
    { key: 'updated_at', label: 'Updated At' },
  ];

  const getValue = (key) => {
    if (key === 'status') {
      const status = data[key];
      return (
        <span className={`badge ${status === 'active' ? 'bg-success' : 'bg-danger'}`}>
          {status ? status.toUpperCase() : 'N/A'}
        </span>
      );
    }
    return data[key] || 'N/A';
  };

  const availableKeys = Object.keys(data).filter(key => !['id'].includes(key));

  return (
    <div className="view-gotra-container">
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <tbody>
            {availableKeys.map((key) => {
              const field = displayFields.find(f => f.key === key);
              const label = field ? field.label : key.replace(/_/g, ' ').toUpperCase();
              return (
                <tr key={key}>
                  <th style={{ width: '40%', backgroundColor: '#f8f9fa' }}>
                    {label}
                  </th>
                  <td>{getValue(key)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewGotra;